/* eslint-disable no-unused-vars */
export enum WrapOrders {
  COLUMN = 'column',
  COLUMN_REVERSE = 'column-reverse',
  ROW = 'row',
  ROW_REVERSE = 'row-reverse',
}
